import { FunctionComponent } from 'react';
import { DefaultChip } from 'shared/DefaultChip';

export const AlphaTag: FunctionComponent = () => {
  return <DefaultChip label="Alpha" color="error" variant="outlined" />;
};
